import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { mockDifferentiators } from '@/mocks/travel';

gsap.registerPlugin(ScrollTrigger);

export default function DifferentiatorsSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const cards = sectionRef.current?.querySelectorAll('.diff-card');
      if (cards) {
        gsap.fromTo(
          cards,
          { y: 50, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 0.7,
            stagger: 0.1,
            ease: 'power3.out',
            scrollTrigger: {
              trigger: sectionRef.current,
              start: 'top 75%',
              toggleActions: 'play none none reverse',
            },
          }
        );
      }
    }, sectionRef);
    return () => ctx.revert();
  }, []);

  return (
    <section id="diferenciais" ref={sectionRef} className="relative w-full py-24 md:py-32 px-6 md:px-10 lg:px-16 bg-background-100">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-16 md:mb-20">
          <span className="inline-block text-xs tracking-[0.2em] uppercase text-accent-600 font-label mb-4">
            Por que nos escolher
          </span>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-light text-foreground-900 leading-tight">
            O que nos torna <span className="italic">diferentes</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {mockDifferentiators.map((item, index) => (
            <div
              key={index}
              className="diff-card group p-8 md:p-10 bg-background-50 border border-background-200/60 rounded-lg hover:border-accent-200/50 transition-all duration-500 cursor-default"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-accent-50 rounded-lg mb-6 group-hover:bg-accent-100 transition-colors duration-500">
                <i className={`${item.icon} text-2xl text-accent-600`}></i>
              </div>
              <h3 className="font-heading text-2xl font-medium text-foreground-900 mb-3">
                {item.title}
              </h3>
              <p className="text-foreground-600 leading-relaxed text-sm">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}